<script lang="ts">
import { defineComponent, h, type Component, type PropType, type VNode } from 'vue'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

const TAG_TO_COMPONENT: Record<string, Component> = {
  table: Table,
  thead: TableHeader,
  tbody: TableBody,
  tr: TableRow,
  th: TableHead,
  td: TableCell,
}

type Child = VNode | string

function nodeToVNode(node: ChildNode): Child | null {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent ?? ''
  }
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return null
  }

  const el = node as HTMLElement
  const tag = el.tagName.toLowerCase()

  const props: Record<string, string> = {}
  for (const attr of Array.from(el.attributes)) {
    props[attr.name] = attr.value
  }

  const children = Array.from(el.childNodes)
    .map(nodeToVNode)
    .filter((c): c is Child => c !== null)

  const component = TAG_TO_COMPONENT[tag]
  if (component) {
    return h(component, props, () => children)
  }
  return h(tag, props, children)
}

export default defineComponent({
  name: 'LegalMarkdownContent',
  props: {
    html: {
      type: String as PropType<string>,
      required: true,
    },
  },
  render() {
    const doc = new DOMParser().parseFromString(`<div>${this.html}</div>`, 'text/html')
    const container = doc.body.firstChild as HTMLElement | null
    if (!container) return null

    return Array.from(container.childNodes)
      .map(nodeToVNode)
      .filter((c): c is Child => c !== null)
  },
})
</script>
